import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { failureMessages, validatePassword } from '../../../common/helpers/Password';
import { mapDispatchToProps, mapStateToProps } from './RecoverPassword.container';

import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import InvalidIcon from '@mui/icons-material/Close';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import ValidIcon from '@mui/icons-material/Check';
import { connect } from 'react-redux';
import { resetPasswordSchema } from './RecoverPassword.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);

export function RecoverPassword(props) {
    const { onCompleteNewPassword } = props;
    const [passwordChecks, updatePasswordChecks] = useState(validatePassword('', true));

    const onPasswordChange = event => {
        updatePasswordChecks(validatePassword(event.target.value, true));
    };
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            <FormikValidationForm
                initialValues={{ newPassword: '', confirmNewPassword: '' }}
                validationSchema={resetPasswordSchema}
                onSubmit={onCompleteNewPassword}
                title="password.reset"
                subtitle="password.requireNew"
                submitText="password.setNew"
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <FormikTextField
                        autoComplete="off"
                        fullWidth
                        label="common.fields.newPassword.label"
                        name="newPassword"
                        type="password"
                        onChange={onPasswordChange}
                        required
                    />
                    <Box p={1} alignContent="flex-start" width="100%">
                        {props.failureMessages.map(([key, message]) => (
                            <Typography gutterBottom key={key} variant="body2">
                                {passwordChecks[key] ? (
                                    <ValidIcon color="success" sx={{ verticalAlign: 'middle' }} />
                                ) : (
                                    <InvalidIcon color="error" sx={{ verticalAlign: 'middle' }} />
                                )}
                                <Box
                                    ml={1}
                                    component="span"
                                    sx={{ lineHeight: 1.5, verticalAlign: 'middle' }}
                                >
                                    <Locale path={message} />
                                </Box>
                            </Typography>
                        ))}
                    </Box>
                    <FormikTextField
                        autoComplete="off"
                        fullWidth
                        label="password.confirmNew"
                        name="confirmNewPassword"
                        type="password"
                        required
                    />
                </Box>
            </FormikValidationForm>
        </Box>
    );
}

RecoverPassword.propTypes = {
    failureMessages: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    onCompleteNewPassword: PropTypes.func.isRequired,
};

RecoverPassword.defaultProps = { failureMessages };
